<template>
  <div class="" :class="cardGridClasses">
    <router-link :to="estudioRouteConfig" id="id-unico-dublador">
      <card type="secondary" shadow hover
        bodyClasses="p-1"
        :class="cardClasses">
        <template>
          <img v-lazy="cover" class="card-img-top">
          <div class="lazyOverlay">
            <img src="img/tail-spin.svg">
          </div>
          <div class="px-2 py-3 title">
            <strong>{{this.estudio.nome}}</strong>
            <span class="badge badge-success d-table" v-if="this.estudio.titulos > 0">{{this.estudio.titulos}} {{ this.estudio.titulos > 1 ? 'títulos' : 'título'}}</span>
            <span class="badge badge-warning d-table" v-else>nenhum título vinculado</span>
          </div>
        </template>
      </card>
    </router-link>
  </div>
</template>
<script>
import Card from '@/components/Card';

export default {
  name: "estudioCard",
  components: {
    Card,
  },
  props: {
    cardGridClasses: {
      type: [String, Object, Array],
      default: "col col-sm-6 col-lg-4 mb-4",
      description: "Individual card grid css classes"
    },
    cardClasses: {
      type: [String, Object, Array],
      default: "bg-white border-0",
      description: "Individual card css classes"
    },
    estudio: {
      type: Object
    }
  },
  computed: {
    cover() {
      return this.axios.defaults.baseURL + this.estudio.imagem
    },
    estudioRouteConfig() {
        return '/estudios/'+this.estudio.id+'/'+this.estudio.slug
    }
  },
  created() {
    
  },
};
</script>
<style>
  .title strong {
    line-height: 1;
  }
</style>
